import { React, useState } from 'react';

const iconPath = '/wp-content/plugins/ace-carnegie-institution-charts/frontend/src/images/widgets/';
let tableIcon = iconPath + 'table.svg';
let tableIconSelected = iconPath + 'table-selected.svg';
let chartIcon = iconPath + 'chart.svg';
let chartIconSelected = iconPath + 'chart-selected.svg';

const TableToggle = ({ handleTable, table }) => {

    const [isHoveringChart, setIsHoveringChart] = useState(false);
    const [isHoveringTable, setIsHoveringTable] = useState(false);

    return (<span className="tableToggles">
        <a href='#' 
            onClick={(e) => handleTable(e, false)}
            onMouseEnter={() => setIsHoveringChart(true)}
            onMouseLeave={() => setIsHoveringChart(false)}
            className={table ? '' : 'active'}>
            {(!table || isHoveringChart) ? (
                <img src={chartIconSelected} alt="Chart Is Selected" />
            ) : (
                <img src={chartIcon} alt="Chart Not Selected" />
            )}
        </a>
        <a href='#' 
            onClick={(e) => handleTable(e, true)}
            onMouseEnter={() => setIsHoveringTable(true)}
            onMouseLeave={() => setIsHoveringTable(false)}
            className={table ? 'active' : ''}>
            {(table || isHoveringTable) ? (
                <img src={tableIconSelected} alt="Table Is Selected" />
            ) : (
                <img src={tableIcon} alt="Table Not Selected" />
            )}
        </a>
    </span>
    )
}

export default TableToggle;